import Vue from 'vue'
import axios from 'axios'
import QS from 'qs';

let baseURL
if (process.env.NODE_ENV === 'development') {
  baseURL = '/api'
} else {
  if (process.env.type === 'test') {
    baseURL = 'https://api.hbzhengwu.com/ds/api/'
  } else {
    baseURL = 'https://api.hbzhengwu.com/ds/api/'
  }
}
// axios.defaults.timeout = 6000;                
// axios.defaults.baseURL = baseURL;
// axios.defaults.responseType = "json";
// axios.defaults.withCredentials = false;

const service = axios.create({
  baseURL: baseURL, // api base_url,
  timeout: 60 * 1000, // 请求超时时间,
  headers: {
    "Content-Type": "application/json"
  },
  withCredentials: true,
  crossDomain: true,
});

service.interceptors.request.use(
  config => {
    var token = window.localStorage.getItem("token")
    if (token && token != "") {
      config.headers.token = token
    }
    // var token = sessionStorage.getItem("account.token") || "";
    // if (token && token != "") {
    //   config.headers = {
    //     "Authorization": 'Bearer ' + token,
    //     'Content-Type': 'application/json; charset=utf-8',
    //   }
    // } else {
    //   config.headers = {
    //     'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
    //   }
    //   config.data = Vue.prototype.qs.stringify(config.data)
    // }
    return config
  },
  error => {
    return Promise.reject(error);
  }
)

service.interceptors.response.use(
  response => {
    if (response.status == 200) {
      if (response.data.code == 20000 && response.data != null) {
        return Promise.resolve(response.data.data)
      } else {
        return Promise.reject(response.data.message)
      }
    } else {
      return Promise.reject(response.errMsg)
    }
  }
)



export function get(url, params) {
  return new Promise((resolve, reject) => {
    service.get(url, {
        params: params
      })
      .then(res => {
        resolve(res);
      })
      .catch(msg => {
        reject(msg)
      })
  });
}

export function post(url, params) {
  return new Promise((resolve, reject) => {
    service.post(url, QS.stringify(params))
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err.data)
      })
  });
}

// export default {
//   install: function (Vue, Option) {
//     Object.defineProperty(Vue.prototype, "$http", {
//       value: service
//     });
//     Object.defineProperty(Vue.prototype, "$get", {
//       value: get
//     });
//     Object.defineProperty(Vue.prototype, "$post", {
//       value: post
//     });
//   }
// };



// WEBPACK FOOTER //
// ./src/network/request.js